// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a6fb4ef","389":"69b6625a","453":"b6b15274","732":"205702de","977":"2916c2b3"}[chunkId] + ".chunk.js";
};